import {BaseApi} from '@/common/api/BaseApi';
import {ApiProperties} from '@/types/common/api/api.types';

export class UserNotificationApi {

  public static api({id, version = 'v1'}: ApiProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/user/notification${id !== undefined ? `/${id}` : ''}`;
  }

  public static stream({version = 'v1'}: ApiProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/user/notification/stream`;
  }
}
